import { render } from "./RegulatoryPermissionsComponent.vue?vue&type=template&id=12ccb9ac"
import script from "./RegulatoryPermissionsComponent.vue?vue&type=script&lang=js"
export * from "./RegulatoryPermissionsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__